import React from 'react';

const TourCourses = () => ({
  run: false,
  stepIndex: 0,
  steps: [
    {
      content: (
        <>
          <p>
            En esta sección podrás gestionar los distintos cursos de un cliente
          </p>
          <p>Dependiendo de tu rol, podrás crear, editar y eliminar cursos</p>
        </>
      ),
      placement: 'center',
      styles: {
        options: {
          width: 900,
        },
      },
      target: 'body',
      title: 'Gestión de cursos',
    },
    {
      title: 'Puedes reiniciar el tour',
      content: (
        <div>
          <h3>Con este botón empieza de nuevo el tour</h3>
        </div>
      ),
      target: '.demo__segundo',
      placement: 'bottom',
    },
    {
      title: 'Este es el listado de cursos disponible',
      content:
        'En este apartado podrás llevar a cabo acciones relacionadas con tus cursos',
      target: '.RaList-main-43',
      placement: 'bottom',
    },
    {
      title: 'Cabecera de la tabla',
      content:
        'Haz click en alguno de los campos para ordenar de manera ascendente o descendente',
      target: '.RaDatagrid-headerRow-75',
      placement: 'bottom',
    },
    {
      title: 'Campo de búsqueda',
      content: 'Aquí podrás buscar por el nombre del cliente',
      target: '#q',
      placement: 'bottom',
    },
    {
      title: 'Crear curso',
      content: 'Aqui podrás ir crear un curso nuevo',
      target:
        '.MuiButtonBase-root.MuiButton-root.MuiButton-text.RaButton-button-6.MuiButton-textPrimary.MuiButton-textSizeSmall.MuiButton-sizeSmall',
      placement: 'bottom',
    },
    {
      title: 'Exportar listado de cursos',
      content: 'Aqui podrás esportyar en formato CSV el listado de cursos',
      target: '[aria-label="Exportar"]',
      placement: 'bottom',
    },
  ],
});

export default TourCourses;
